// External modules
import PropTypes from 'prop-types';
import React from 'react';

// Internal modules

function Callback({ authProperties }) {
  if (!authProperties) return null;

  const { auth } = authProperties;
  if (!authProperties || !auth) return null;

  const { web: webAuthConfig } = auth.getAuthConfig();
  if (!webAuthConfig || !webAuthConfig.audienceKey) return null;

  const webAuth = auth.getWebAuth(webAuthConfig.audienceKey);
  if (!webAuth || !webAuth.popup) return null;

  webAuth.popup.callback();
  return <div>Logging in...</div>;
}

Callback.propTypes = {
  authProperties: PropTypes.object.isRequired,
};

Callback.defaultProps = {};

export default Callback;
